/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface RewriteSignatures$Params {}

export function rewriteSignatures(
  http: HttpClient,
  rootUrl: string,
  params?: RewriteSignatures$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, rewriteSignatures.PATH, 'post');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    }),
  );
}

rewriteSignatures.PATH = '/service/v1/afterSales/rewriteSignatures';
